export default "__VITE_ASSET__Bv7b$Dwr__"